export default Object.freeze({
  get (key) {
    const str = window.localStorage.getItem(key)
    if (typeof str !== 'string') {
      return null
    }

    try {
      const parseRes = JSON.parse(str)
      try {
        return JSON.parse(parseRes)
      } catch (err) {
        return parseRes
      }
    } catch (err) {
      if (typeof str === 'string') {
        return str
      } else return null
    }
  },

  set (key, value) {
    if (value === undefined) {
      return
    }
    // use JSON.stringify to transform shits
    return window.localStorage.setItem(key, JSON.stringify(value))
  },

  remove (key) {
    return window.localStorage.removeItem(key)
  },

  clear () {
    return window.localStorage.clear()
  },

  has (key) {
    return Boolean(this.get(key))
  },

  is (key, value) {
    return value === this.get(key)
  }
})
